import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSidebar = _resolveComponent("LeftSidebar")!
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AddNewTaskPopup = _resolveComponent("AddNewTaskPopup")!
  const _component_AddNewCardPopup = _resolveComponent("AddNewCardPopup")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.shouldShowSidebar && !_ctx.isNotFound)
      ? (_openBlock(), _createBlock(_component_LeftSidebar, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.shouldShowHeader && !_ctx.isNotFound)
      ? (_openBlock(), _createBlock(_component_TopHeader, { key: 1 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'main-content transition-all flex flex-col overflow-hidden min-h-screen',
        {
          active: _ctx.stateStoreInstance?.open,
          'padding-minus': _ctx.shouldShowPaddingZero || _ctx.isNotFound,
        },
      ])
    }, [
      _createVNode(_component_router_view),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "grow" }, null, -1))
    ], 2),
    _createVNode(_component_AddNewTaskPopup),
    _createVNode(_component_AddNewCardPopup),
    _createVNode(_component_Toast)
  ]))
}